import { render, staticRenderFns } from "./AProductSelector.vue?vue&type=template&id=f344ac6c&scoped=true&"
import script from "./AProductSelector.vue?vue&type=script&lang=js&"
export * from "./AProductSelector.vue?vue&type=script&lang=js&"
import style0 from "./AProductSelector.vue?vue&type=style&index=0&id=f344ac6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f344ac6c",
  null
  
)

export default component.exports